import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect } from 'react';
import { logStore } from '../stores/logStore';
const LogContext = createContext(null);
export const ErrorProvider = ({ children, onError }) => {
    useEffect(() => {
        return logStore.getState().registerLogger(onError);
    }, [onError]);
    return _jsx(LogContext.Provider, { value: null, children: children });
};
